import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  align-items: center;

  @media (${mobileXXLargeMax}) {
    padding-left: 15px;
  }
`;

export default Container;
